// frontend/src/pages/ContactPage.tsx
import { InfoPageLayout } from './InfoPageLayout';

export function ContactPage() {
  return (
    <InfoPageLayout title="Contact Us" documentTitle="Contact" metaDescription="Contact the Llambada team — get support, report issues, share feedback, or discuss partnerships. We respond within 24-48 hours.">
      <h2>Get in Touch</h2>
      <p>
        We're here to help with any questions, concerns, or feedback you may have about 
        Llambada. Our team is committed to providing excellent support and continuously 
        improving your experience.
      </p>

      <h2>Support</h2>
      <p>
        For technical support, account issues, or questions about using Llambada, please 
        reach out to our support team:
      </p>
      <p>
        <strong>Email:</strong> <a href="mailto:support@llambada.com">support@llambada.com</a>
      </p>
      <p>
        We typically respond to all support inquiries within 24-48 hours during business days. 
        For faster resolution, please include:
      </p>
      <ul>
        <li>Your account email address</li>
        <li>A description of the issue you're experiencing</li>
        <li>The name of the mini-app involved (if applicable)</li>
        <li>Any error messages you've seen</li>
        <li>Steps to reproduce the problem</li>
      </ul>

      <h2>Creator Support</h2>
      <p>
        Questions about publishing mini-apps, revenue sharing, or payouts? Our creator support 
        team can help:
      </p>
      <p>
        <strong>Email:</strong> <a href="mailto:creators@llambada.com">creators@llambada.com</a>
      </p>

      <h2>Feedback and Suggestions</h2>
      <p>
        Your feedback helps us improve Llambada for everyone. If you have ideas for new 
        features, suggestions for improvements, or thoughts on how we can better serve your 
        needs, we'd love to hear from you.
      </p>
      <p>
        <strong>Email:</strong> <a href="mailto:feedback@llambada.com">feedback@llambada.com</a>
      </p>

      <h2>Business Inquiries</h2>
      <p>
        For partnerships, enterprise licensing, API access, or other business-related questions:
      </p>
      <p>
        <strong>Email:</strong> <a href="mailto:business@llambada.com">business@llambada.com</a>
      </p>

      <h2>Legal and Privacy</h2>
      <p>
        For legal matters, privacy concerns, or data-related requests:
      </p>
      <p>
        <strong>Privacy:</strong> <a href="mailto:privacy@llambada.com">privacy@llambada.com</a>
      </p>
      <p>
        <strong>Legal:</strong> <a href="mailto:legal@llambada.com">legal@llambada.com</a>
      </p>
      <p>
        <strong>Copyright:</strong> <a href="mailto:copyright@llambada.com">copyright@llambada.com</a>
      </p>

      <h2>Report Abuse</h2>
      <p>
        If you encounter a mini-app that violates our terms of service, contains malicious 
        content, or is being used for abuse, please report it immediately:
      </p>
      <p>
        <strong>Email:</strong> <a href="mailto:abuse@llambada.com">abuse@llambada.com</a>
      </p>
      <p>
        Please include the URL of the mini-app and a description of the issue.
      </p>

      <h2>Mailing Address</h2>
      <p>
        <a href="https://chapterpal.com" target="_blank" rel="noopener noreferrer" className="text-accent-500 hover:underline">ChapterPal Inc</a>.<br />
        410-117 Quai St-André<br />
        Québec, QC<br />
        Canada
      </p>

      <h2>Response Times</h2>
      <p>
        We strive to respond to all inquiries as quickly as possible:
      </p>
      <ul>
        <li><strong>Support requests:</strong> Within 24-48 hours</li>
        <li><strong>Abuse reports:</strong> Within 24 hours</li>
        <li><strong>Business inquiries:</strong> Within 3-5 business days</li>
        <li><strong>Legal/privacy requests:</strong> Within 30 days (as required by law)</li>
      </ul>
    </InfoPageLayout>
  );
}
